import { useLocation, useNavigate } from 'react-router-dom'
import { Switch, SwitchProps, styled } from '@mui/material'
import { RoutePath } from '../../constants'
//import bostonUniversityLogo from './images/bu-center-logo-table.png'
import styles from './TableToggle.module.scss'

const CustomSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 76,
  height: 42,
  padding: 0,
  border: `1px solid #222222`,
  borderRadius: 21,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 7,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      paddingLeft: 16,
      '& + .MuiSwitch-track': {
        backgroundColor: '#e9e7e1',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#222222',
      border: '6px solid #222222',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: '#222222',
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 28,
    height: 28,
    color: '#222222',
  },
  '& .MuiSwitch-track': {
    backgroundColor: '#e9e7e1',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
    width: '100%',
  },
}))

export const TableToggle = () => {
  const { pathname: viewType } = useLocation()
  const navigate = useNavigate()

  return (
    <div className="flex flex-1 mb-16 flex-col gap-8">
      <div className="flex gap-4 items-center justify-between w-[80%]">
        <div className="flex flex-col gap-2 w-[230px] relative">
          <div className={styles.arrowAlt}></div>
          <div className={styles.arrowHeadAlt}></div>
          <p className="uppercase font-decimal font-bold text-green text-[14px]">
            Don't see your organization on the map?
          </p>
          <div
            role="button"
            className="w-fit cursor-pointer"
            onClick={() => navigate(RoutePath.AddOrganization)}
          >
            <p className="uppercase font-decimal text-[14px] text-black underline">
              + Organization
            </p>
          </div>
        </div>
        <div className="flex gap-4 items-center">
          <p className="uppercase font-decimal text-black text-[14px]">Map</p>
          <CustomSwitch
            checked={viewType === RoutePath.Table}
            onChange={() => {
              if (viewType === RoutePath.Map) {
                if (typeof window.gtag === 'function') {
                  window.gtag('event', 'view_toggle', { view: 'table' })
                }
                navigate(RoutePath.Table)
              } else {
                if (typeof window.gtag === 'function') {
                  window.gtag('event', 'view_toggle', { view: 'map' })
                }
                navigate(RoutePath.Map)
              }
            }}
            inputProps={{ 'aria-label': 'toggle between map and table' }}
          />
          <p className="uppercase font-decimal text-black text-[14px]">Table</p>
        </div>
        <div />
      </div>
      <div className="flex justify-end w-full">
        {/* <div className="flex flex-col gap-2">
          <p className="font-decimal text-[14px] text-black">
            Data provided by:
          </p>
          <a
            className="font-decimal text-[14px] text-black underline"
            href="https://www.bu.edu/antiracism-center/"
            target="_blank"
            rel="noreferrer"
          >
            <img
              width="223px"
              height="24px"
              src={bostonUniversityLogo}
              alt="Boston University Center for Antiracist Research."
            />
          </a>
        </div> */}
        <p className="font-decimal text-[14px] text-black">
          Designed and built by&nbsp;
          <a
            className="font-bold no-underline"
            href="https://graphicacy.com/"
            target="_blank"
            rel="noreferrer"
          >
            Graphicacy
          </a>
        </p>
      </div>
    </div>
  )
}
